import React from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { bool, number, object, func } from 'prop-types';
import { isNil } from 'ramda';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import ArrowBackIosSharpIcon from '@material-ui/icons/ArrowBackIosSharp';
import piwik from '../../../../services/analytics/analytics';
import { eventTags } from '../../../../services/analytics/tags';
import LinearProgress from './components/LinearProgress/LinearProgress';
import ROUTES from '../../../../routes';
import { useConnect } from './hooks';
import messages from '../../messages';

const MyAppBar = ({ stepperMax, stepperValue, settings: { WORKFLOW_BUTTON_BACK }, isWorkflowBackButtonEnabled, back }) => {
  const { isImpressumUrlVisible, impressumUrl } = useConnect();
  const { pathname } = useLocation();

  const IS_ON_LEGISLATION_PAGE = pathname === ROUTES.LEGISLATION.path;
  const IS_BACK_ENABLED = IS_ON_LEGISLATION_PAGE || (WORKFLOW_BUTTON_BACK && isWorkflowBackButtonEnabled);

  const handleBack = () => {
    if (IS_ON_LEGISLATION_PAGE) {
      window.close();
    } else {
      piwik.trackEvent(eventTags.back_to_previous_page);
      back();
    }
  };

  return (
    <Grid>
      <AppBar position="static">
        <Toolbar style={{ height: '50px', minHeight: '50px' }}>
          <Grid container>
            {IS_BACK_ENABLED && (
              <Grid item>
                <IconButton name="back" color="inherit" onClick={handleBack}>
                  <ArrowBackIosSharpIcon color="inherit" />
                </IconButton>
              </Grid>
            )}
          </Grid>
          <Grid>
            {isImpressumUrlVisible && (
              <Link href={impressumUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
                <FormattedMessage {...messages.impressum} />
              </Link>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
      {!isNil(stepperValue) && stepperMax && <LinearProgress value={(stepperValue / stepperMax) * 100} />}
    </Grid>
  );
};

MyAppBar.propTypes = {
  stepperMax: number,
  stepperValue: number,
  settings: object.isRequired,
  isWorkflowBackButtonEnabled: bool,
  back: func.isRequired,
};

export default MyAppBar;
